module.exports = __webpack_public_path__ + "media/images/physicianestate-sq-635e8f4edbf82baf8e971aad9e7a997c.png";